import React from 'react';
import html from '../files/html.png'
import css from '../files/css.png'
import bootstrap from '../files/bootstrap.png'
import tailwind from '../files/tailwind.png'
import js from '../files/js.png'
import ts from '../files/ts.png'
import psql from '../files/psql.png'
import react from '../files/react.png'
import prisma from '../files/prisma.png'
import rb from '../files/rb.png'
import dui from '../files/dui.png'
import redis from '../files/redis.png'
import express from '../files/express.png'
import MongoDB from '../files/mongoDB.png'
import axios from '../files/axios.png'
import heroku from '../files/heroku.png'
import stripe from '../files/stripe.png'
import git from '../files/git.png'
import figma from '../files/figma.png'
import vscode from '../files/vscode.png'
import dev from '../files/dev.png'
import netlify from '../files/netlify.png'
import npm from '../files/npm.png'
import mongoose from '../files/mongoose.png'
import jwt from '../files/jwt.png'
import next from '../files/next.png'
import redux from '../files/redux.png'
import mui from '../files/mui.png';
import ad from '../files/ad.svg';
import recharts from '../files/recharts.png';
import zod from '../files/zod.png';
import github2 from '../files/github2.png';
import yarn from '../files/yarn.png';



const skills = [
    {
        index: 1,
        section: 'Languages',
        skills: [
            { name: "HTML5", img: html },
            { name: "CSS3", img: css },
            { name: "JavaScript", img: js },
            { name: "TypeScript", img: ts },
        ]
    },
    {
        index: 2,
        section: 'Libraries / Frameworks',
        skills: [
            { name: "React JS", img: react },
            { name: "Next JS", img: next },
            { name: "Redux-Toolkit", img: redux },
            { name: "Express JS", img: express },
            { name: "Mongoose", img: mongoose },
            { name: "Prisma", img: prisma },
            { name: "JWT", img: jwt },
            { name: "Zod", img: zod },
            { name: "Tailwind CSS", img: tailwind },
            { name: "Bootstrap", img: bootstrap },
            { name: "Material UI", img: mui },
            { name: "React-Bootstrap", img: rb },
            { name: "Daisy UI", img: dui },
            { name: "Ant Design", img: ad },
        ]
    },
    {
        index: 3,
        section: 'Databases',
        skills: [
            { name: "MongoDB", img: MongoDB },
            { name: "PostgreSQL", img: psql }
        ]
    },
    {
        index: 4,
        section: 'Tools',
        skills: [
            { name: "Git", img: git },
            { name: "GitHub", img: github2 },
            { name: "npm", img: npm },
            { name: "yarn", img: yarn },
            { name: "Axios", img: axios },
            { name: "VS Code", img: vscode },
            { name: "Chrome Dev Tools", img: dev }
        ]
    },
]




function Skills() {
    return (
        <div id='skills' className=' bg-[#18191A]  lg:flex  '>

            <div className='lg:w-9/12 lg:mx-auto md:mx-20 ml-6 pb-10 '>
                <h2 data-aos="fade-up" data-aos-duration="1000" data-aos-offset="300" data-aos-easing="ease-in-sine" className='lg:text-5xl text-3xl font-semibold text-[#17A875] pt-12 text-center'>Skills</h2>


                <div className=''>
                    {
                        skills?.map(skill => (
                            <div key={skill}>
                                <h4 className='text-3xl text-[#17A875] mb-6 mt-14'>- {skill?.section}</h4>
                                <div className='grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-4'>
                                    {
                                        skill?.skills?.map(tech => (
                                            <p className='skillCard '>
                                                <img className='w-6 h-6' src={tech?.img} alt="" />
                                                <p className='ml-3'>{tech?.name}</p>
                                            </p>
                                        ))
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>



            </div>
        </div>
    )
}

export default Skills;
